var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"entering-class"},[_c('LayoutsHeaderTheHeader'),_vm._v(" "),_c('Nuxt',{staticClass:"nuxt-content"}),_vm._v(" "),_c('LayoutsFooterTheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }